import { valsOrNone } from '@quromedical/fhir-common';

const doseAddressHaveData = (
  address?: fhir4.Address,
): address is fhir4.Address => {
  const hasValue = !!address;
  if (!hasValue) {
    return false;
  }
  const hasLines = address.line?.length;
  const hasData =
    address.city ||
    address.country ||
    address.state ||
    address.postalCode ||
    address.district ||
    address.extension ||
    hasLines;

  return !!hasData;
};

export const createAddressList = (
  address?: fhir4.Address,
): fhir4.Address[] | undefined => {
  const hasAddress = doseAddressHaveData(address);
  if (!hasAddress) {
    return undefined;
  }
  return [{ ...address, line: valsOrNone(address.line) }];
};
